<template>
  <div class="access-page">
    <h1>Accès au Film</h1>
    <p>Veuillez entrer votre code d'accès et votre adresse e-mail pour visionner le film complet.</p>
    <!-- Ajoute un formulaire plus tard pour entrer le code et l'e-mail -->
  </div>
</template>

<script>
export default {
  name: 'AccessPage',
};
</script>

<style scoped>
.access-page {
  text-align: center;
  margin-top: 2em;
}
</style>
